import {rtkQueryApi} from '../../../../shared/api/rtk-query-api';

export const filesApi = rtkQueryApi
  .enhanceEndpoints({
    addTagTypes: ['files'],
  })
  .injectEndpoints({
    endpoints: builder => ({
      createFile: builder.mutation({
        query: file => {
          return {
            url: 'file',
            method: 'POST',
            body: file,
          };
        },
      }),
    }),
  });

export const {useCreateFileMutation} = filesApi;
